import { supabase, AppUser } from './supabase';

export async function loginWithPhone(phone: string, password: string): Promise<{ user: AppUser | null; error: string | null }> {
  // Backend integration point: Replace with proper bcrypt comparison in production
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('phone', phone)
    .eq('password_hash', password)
    .single();

  if (error || !data) {
    return { user: null, error: 'เบอร์โทรหรือรหัสผ่านไม่ถูกต้อง' };
  }

  return { user: data as AppUser, error: null };
}

export function saveUserSession(user: AppUser) {
  if (typeof window !== 'undefined') {
    localStorage.setItem('rentbyhour_user', JSON.stringify(user));
  }
}

export function getUserSession(): AppUser | null {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('rentbyhour_user');
    if (stored) {
      try {
        return JSON.parse(stored) as AppUser;
      } catch {
        return null;
      }
    }
  }
  return null;
}

export function clearUserSession() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('rentbyhour_user');
  }
}